<template>
  <div class="sidebar">
    <SidebarHeader/>
    <SidebarForm/>
    <div class="sidebar-nav">
        <div class="sidebar-header">
            <div class="img-avatar">
                <avatar :username="user.firstname+' '+user.lastname" :size="80"></avatar>
            </div>
            <!--<img src="static/img/avatars/8.jpg" class="img-avatar" alt="Avatar">-->
            <div><strong>{{user.firstname}} {{user.lastname}}</strong></div>
           
            <div class="btn-group" role="group" aria-label="Button group with nested dropdown">

                <button type="button" class="btn btn-link text-lowercase" v-on:click="logout">
                    <i class="icon-logout"></i> Esci
                </button>
            </div>
        </div>
        
        <slot>
            <nav class="sidebar-nav open">
                <ul class="nav">
                    <li class="nav-item">
                        <a class="nav-link" href="#/"><i class="icon-speedometer"></i>Home</a>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{ name: 'route-tagtype-list'}" class="nav-link"><font-awesome-icon icon="eye" ref="viewIcon"></font-awesome-icon> Tipologia tags</router-link>

                    </li>
                    <li class="nav-item">
                        <router-link :to="{ name: 'route-tag-list'}" class="nav-link"><font-awesome-icon icon="tag" ref="viewIcon"></font-awesome-icon> Tags</router-link>

                    </li>
                    <li class="nav-item">
                        <router-link :to="{ name: 'route-company-list'}" class="nav-link"><font-awesome-icon icon="building"></font-awesome-icon> Aziende</router-link>

                    </li>

                </ul>
            </nav>
        </slot>
    </div>
    
    <SidebarFooter/>
    <SidebarMinimizer/>
  </div>
</template>
<script>
import SidebarFooter from './SidebarFooter'
import SidebarForm from './SidebarForm'
import SidebarHeader from './SidebarHeader'
import SidebarMinimizer from './SidebarMinimizer'
import SidebarNavDivider from './SidebarNavDivider'
import SidebarNavDropdown from './SidebarNavDropdown'
import SidebarNavLink from './SidebarNavLink'
import SidebarNavTitle from './SidebarNavTitle'
import SidebarNavItem from './SidebarNavItem'
    import SidebarNavLabel from './SidebarNavLabel'
    import Avatar from 'vue-avatar'
export default {
        name: 'sidebar',
        computed: {
            user() {
                return this.$store.state.user;
            },
        },
        props: {
            navItems: {
                type: Array,
                required: false,
                default: () => []
            }
        },
        components: {
            Avatar,
            SidebarFooter,
            SidebarForm,
            SidebarHeader,
            SidebarMinimizer,
            SidebarNavDivider,
            SidebarNavDropdown,
            SidebarNavLink,
            SidebarNavTitle,
            SidebarNavItem,
            SidebarNavLabel
        },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
      },

      logout() {
          this.$store.dispatch('logout');
          this.$router.push({ name: 'route-login' });

      }
  }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>
